import AlertOctagonFilledIcon from '@elementor/icons/AlertOctagonFilledIcon';
import Box from '@elementor/ui/Box';
import Chip from '@elementor/ui/Chip';
import Typography from '@elementor/ui/Typography';
import { styled } from '@elementor/ui/styles';
import { useMemo } from 'react';
import { colorData } from '@types/color-data';
import { __, sprintf } from '@utils/i18n';
import { injectTemplateVars } from '@utils/inject-template-vars';

const ContrastLevel = ({ colorData }) => {
	const initialRatio = useMemo(() => colorData.ratio, []);

	return (
		<StyledLevelWrapper>
			<Typography as="span" variant="subtitle2">
				{injectTemplateVars(
					sprintf(
						__('Contrast level: {{statusColor}}%s{{/statusColor}}'),
						`${initialRatio}/${colorData.largeText ? 3 : 4.5}`,
					),
					{
						statusColor: ({ children }) => (
							<Typography
								as="span"
								variant="subtitle2"
								sx={{ color: '#DC2626' }}
							>
								{children}
							</Typography>
						),
					},
				)}
			</Typography>

			<Chip
				size="small"
				color="error"
				variant="filled"
				shape="rounded"
				label={__('Fail')}
				icon={<AlertOctagonFilledIcon />}
			/>
		</StyledLevelWrapper>
	);
};

const StyledLevelWrapper = styled(Box)`
	display: flex;
	justify-content: flex-start;
	align-items: center;

	gap: 8px;
`;

ContrastLevel.propTypes = {
	colorData: colorData.isRequired,
};

export default ContrastLevel;
